// @flow
import $ from "./vendor/jquery";

class CsvGenerator {
    constructor(dataArray, fileName, separator, addQuotes) {
        this.dataArray = dataArray;
        this.fileName = fileName;
        this.separator = separator || ';';
        this.addQuotes = !!addQuotes;

        if (this.addQuotes) {
            this.separator = '"' + this.separator + '"';
        }
    }

    getCsvData() {
        let separator = this.separator;
        let addQuotes = this.addQuotes;

        let rows = this.dataArray.map(function (row) {
            let rowData = row.join(separator);

            if (rowData.length && addQuotes) {
                return '"' + rowData + '"';
            }

            return rowData;
        });

        return rows.join('\n');
    }

    getDownloadLink() {
        let type = 'data:text/csv;charset=utf-8';
        let data = this.getCsvData();

        if (typeof btoa === 'function') {
            type += ';base64';
            data = btoa(data);
        } else {
            data = encodeURIComponent(data);
        }

        return this.downloadLink = this.downloadLink || type + ',' + data;
    }

    getLinkElement(linkText) {
        let downloadLink = this.getDownloadLink();
        return this.linkElement = this.linkElement || $('<a>' + (linkText || '') + '</a>', {
            href: downloadLink,
            download: this.fileName
        });
    }

    // call with removeAfterDownload = true if you want the link to be removed after downloading
    download(removeAfterDownload) {
        if (window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([this.getCsvData()], {
                type: "text/csv;charset=utf-8;"
            });
            navigator.msSaveBlob(blob, this.fileName);
        } else {
            this.getLinkElement().css('display', 'none').appendTo('body');
            this.getLinkElement()[0].click();
            if (removeAfterDownload) {
                this.getLinkElement().remove();
            }
        }
    }
}

export default CsvGenerator;
